import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ThankYou.module.css';

export default function ThankYou() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}>✓</div>
        <h1 className={styles.title}>Thank You!</h1>
        <p className={styles.sub}>Your FEwB Alumni Questionnaire has been submitted successfully.</p>
        <p className={styles.body}>
          Your profile has been added to the FEwB roster. We will be in touch when deployment opportunities matching your expertise arise. Thank you for your continued commitment to global public health.
        </p>
        <Link to="/" className={styles.btn}>Submit Another Response</Link>
      </div>
    </div>
  );
}
